import React, { useState } from 'react';
import { Form, Input, Button, Typography, message, Steps } from 'antd';
import { UserOutlined, LockOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

const { Title } = Typography;
const { Step } = Steps;

const Signup = () => {
    const [loading, setLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [phone, setPhone] = useState('');
    const navigate = useNavigate();

    const onFinishStep1 = async (values) => {
        setLoading(true);
        try {
            // 먼저 전화번호로 OTP를 요청합니다.
            const { data, error } = await supabase.auth.signInWithOtp({
                phone: values.phone,
            });

            if (error) throw error;

            setPhone(values.phone);
            setCurrentStep(1);
            message.success('인증 코드가 전송되었습니다.');
        } catch (error) {
            message.error(error.message);
        }
        setLoading(false);
    };

    const onFinishStep2 = async (values) => {
        setLoading(true);
        try {
            // OTP를 확인합니다.
            const { data, error } = await supabase.auth.verifyOtp({
                phone: phone,
                token: values.token,
                type: 'sms'
            });

            if (error) throw error;

            console.log(phone)
            // OTP 확인 후, 실제 회원가입을 진행합니다.
            const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
                email: values.email,
                password: values.password,
                phone: phone,
            });

            if (signUpError) throw signUpError;

            message.success('회원가입이 완료되었습니다!');
            navigate('/login');
        } catch (error) {
            message.error(error.message);
        }
        setLoading(false);
    };

    return (
        <div style={{ maxWidth: 400, margin: '0 auto', marginTop: 50 }}>
            <Title level={2} style={{ textAlign: 'center' }}>회원가입</Title>
            <Steps current={currentStep} style={{ marginBottom: 24 }}>
                <Step title="전화번호 인증" />
                <Step title="회원 정보 입력" />
            </Steps>
            {currentStep === 0 ? (
                <Form name="signup_step1" onFinish={onFinishStep1}>
                    <Form.Item
                        name="phone"
                        rules={[{ required: true, message: '전화번호를 입력해주세요!' }]}
                    >
                        <Input prefix={<PhoneOutlined />} placeholder="전화번호 (예: +821012345678)" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={loading}>
                            인증 코드 받기
                        </Button>
                    </Form.Item>
                </Form>
            ) : (
                <Form name="signup_step2" onFinish={onFinishStep2}>
                    <Form.Item
                        name="token"
                        rules={[{ required: true, message: '인증 코드를 입력해주세요!' }]}
                    >
                        <Input prefix={<LockOutlined />} placeholder="인증 코드" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        rules={[
                            { required: true, message: '이메일을 입력해주세요!' },
                            { type: 'email', message: '올바른 이메일 형식이 아닙니다!' }
                        ]}
                    >
                        <Input prefix={<MailOutlined />} placeholder="이메일" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            { required: true, message: '비밀번호를 입력해주세요!' },
                            { min: 6, message: '비밀번호는 최소 6자 이상이어야 합니다!' }
                        ]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="비밀번호" />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{ width: '100%' }} loading={loading}>
                            가입 완료
                        </Button>
                    </Form.Item>
                </Form>
            )}
        </div>
    );
};

export default Signup;